import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'

const ViewApplication = () => {

    const { id } = useParams();
    const [application, setApplication] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0)
        if (!id) return;

        const getAPP = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getsingleapplication/${id}`);
                if (response) {
                    setApplication(response.data);
                    console.log(response.data)
                }
            } catch (error) {
                console.error('There was an error fetching the job!', error);
            }
        };

        getAPP();
    }, [id]);


    const [applicationStatus, setApplicationStatus] = useState();
    const [statusModalOpen, setStatusModalOpen] = useState(false);

    const handleOpenStatusModal = () => {
        console.log(application);

        // Determine the current status based on the status array
        if (application?.status[2].FinalInterview) {
            setApplicationStatus('finalinterview');
        } else if (application?.status[1].Shortlisted) {
            setApplicationStatus('shortlisted');
        } else if (application?.status[0].Screening) {
            setApplicationStatus('screening');
        }

        setStatusModalOpen(true);
    };

    const handleCloseStatusModal = () => {
        setApplicationStatus()
        setStatusModalOpen(false);
    };
    
    
    const handleUpdateStatus = async (status) => {
        setApplicationStatus(status);

        try {
            // Construct the updated status array
            const updatedStatus = application?.status.map(item => {
                const key = Object.keys(item)[0]; // Get the status key (Screening, Shortlisted, FinalInterview)
                return {
                    [key]: key.toLowerCase() === status.toLowerCase(), // Set the matching status to true, others to false
                    date: key.toLowerCase() === status.toLowerCase() ? new Date() : item.date //update the date if it is the correct status.
                };
            });

            // Prepare the data to send to the backend
            const updateData = {
                status: updatedStatus,
            };

            // Make the API call using axios.post (or axios.put, depending on your API)
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/jobs/updatestatus`, { // Replace with your API endpoint

                updateData,
                applicationID: application?.applicationID,
            }

            );

            // Handle the response (e.g., show a success message)
            console.log('Status updated successfully:', response.data);
            //potentially update the selected application with the new data.
            setApplication({ ...application, status: response.data.status });

        } catch (error) {
            // Handle errors (e.g., show an error message)
            console.error('Error updating status:', error);
            if (error.response) {
                console.error('Server response:', error.response.data);
            }
        }
    };

    // const downloadExcel = () => {
    //     const data = applications.map((application) => ({
    //         ApplicationID: application.applicationID,
    //         Email: application.email,
    //         AppliedAt: new Date(application.appliedAt).toLocaleString(),
    //         // Add other fields as needed
    //         ...application.answers.reduce((acc, answer) => {
    //             acc[answer.question] = answer.answer;
    //             return acc;
    //         }, {}),
    //     }));

    //     const worksheet = XLSX.utils.json_to_sheet(data);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Applications');
    //     XLSX.writeFile(workbook, 'applications.xlsx');
    // };


    return (
        <div className="bigscreen px-16 py-10">
            <div className="w-full max-w-[900px] bg-white rounded-[32px] shadow py-6 px-8 flex flex-col gap-6 mx-auto">

                {/* Header */}
                <div>
                    <h3 className="text-2xl font-bold text-gray-900">Application Details</h3>
                    <p className="text-sm text-gray-500 border-b pb-3">View the details of the application.</p>
                </div>

                {/* Application Information */}
                <div className="bg-gray-100 rounded-lg p-4">
                    <p className="text-sm text-gray-700"><strong>Application ID:</strong> {application?.applicationID}</p>
                    <p className="text-sm text-gray-700"><strong>Email:</strong> {application?.email}</p>
                    <p className="text-sm text-gray-700"><strong>Applied At:</strong> {new Date(application?.appliedAt).toLocaleString()}</p>

                </div>

                <div className='flex gap-4 justify-start'>

                    <button
                        onClick={() => {
                            if (application?.resumeURL) {
                                window.open(application?.resumeURL, '_blank');
                            } else {
                                console.error("Application URL is missing.");
                                alert("Application URL is missing.");
                            }
                        }}
                        className="bg-green-500 hover:bg-green-700 text-white py-1 px-3 rounded text-sm transition-colors duration-300"
                    >
                        View CV
                    </button>
                    <button
                        className="bg-yellow-500 text-white px-3 py-1 rounded text-sm"
                        onClick={() => handleOpenStatusModal()}
                    >
                        Status
                    </button>
                    {/* <button
                        className="bg-yellow-500 text-white px-3 py-1 rounded text-sm"
                        onClick={() => downloadExcel()}
                    >
                        Download to Excel
                    </button> */}
                </div>

                {/* Answers Section */}
                <div>
                    <h4 className="text-lg font-semibold text-gray-900">Answers</h4>
                    <div className="mt-4 space-y-4">
                        {application?.answers?.map((qa, index) => (
                            <div key={index} className="p-4 bg-gray-50 border-l-4 border-blue-500 rounded-lg shadow-sm">
                                <p className="text-gray-900 font-medium">{qa.question}</p>
                                <p className="text-gray-700 mt-1">{qa.answer}</p>
                            </div>
                        ))}
                    </div>
                </div>

            </div>

            {/* Status Modal */}
            {statusModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                    <div className="bg-white p-8 rounded-md min-w-96">
                        <h2 className="text-lg font-semibold mb-6">Edit Status</h2>

                        <div className="mb-6">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Status:
                            </label>
                            <div className="mt-4">
                                <div className="flex items-center justify-between relative">
                                    {/* Status Modal Content - Same as before */}
                                    <div className="relative z-10 mr-4">
                                        <div
                                            className={`w-10 h-10 rounded-full flex items-center justify-center ${applicationStatus === 'screening' ||
                                                applicationStatus === 'shortlisted' ||
                                                applicationStatus === 'finalinterview'
                                                ? 'bg-blue-500 text-white'
                                                : 'bg-gray-300 text-gray-600'
                                                }`}
                                        >
                                            1
                                        </div>
                                        <span className="absolute left-1/2 -translate-x-1/2 text-xs mt-2">
                                            Screening
                                        </span>
                                    </div>

                                    <div
                                        className={`h-1 bg-gray-300 absolute top-5 left-6 w-[calc(50%-40px)] ${applicationStatus === 'shortlisted' ||
                                            applicationStatus === 'finalinterview'
                                            ? '!bg-blue-500'
                                            : ''
                                            }`}
                                    />

                                    <div className="relative z-10 mx-4">
                                        <div
                                            className={`w-10 h-10 rounded-full flex items-center justify-center ${applicationStatus === 'shortlisted' ||
                                                applicationStatus === 'finalinterview'
                                                ? 'bg-blue-500 text-white'
                                                : 'bg-gray-300 text-gray-600'
                                                }`}
                                        >
                                            2
                                        </div>
                                        <span className="absolute left-1/2 -translate-x-1/2 text-xs mt-2">
                                            Shortlisted
                                        </span>
                                    </div>

                                    <div
                                        className={`h-1 bg-gray-300 absolute top-5 right-6 w-[calc(50%-40px)] ${applicationStatus === 'finalinterview' ? '!bg-blue-500' : ''
                                            }`}
                                    />

                                    <div className="relative z-10 ml-4">
                                        <div
                                            className={`w-10 h-10 rounded-full flex items-center justify-center ${applicationStatus === 'finalinterview'
                                                ? 'bg-blue-500 text-white'
                                                : 'bg-gray-300 text-gray-600'
                                                }`}
                                        >
                                            3
                                        </div>
                                        <span className="w-full absolute left-1/2 -translate-x-1/2 text-xs mt-2">
                                            Final-Interview
                                        </span>
                                    </div>
                                </div>

                                <div className="flex justify-center gap-4 mt-14">
                                    {/* Status Update Buttons */}
                                    <button
                                        className={`px-4 py-2 rounded text-sm ${applicationStatus === 'screening'
                                            ? 'bg-blue-500 text-white'
                                            : 'bg-gray-200'
                                            }`}
                                        onClick={() => handleUpdateStatus('screening')}
                                    >
                                        Set to Screening
                                    </button>
                                    <button
                                        className={`px-4 py-2 rounded text-sm ${applicationStatus === 'shortlisted'
                                            ? 'bg-blue-500 text-white'
                                            : 'bg-gray-200'
                                            }`}
                                        onClick={() => handleUpdateStatus('shortlisted')}
                                    >
                                        Set to Shortlisted
                                    </button>
                                    <button
                                        className={`px-4 py-2 rounded text-sm ${applicationStatus === 'finalinterview'
                                            ? 'bg-blue-500 text-white'
                                            : 'bg-gray-200'
                                            }`}
                                        onClick={() => handleUpdateStatus('finalinterview')}
                                    >
                                        Set to Final Interview
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button className="bg-red-300 px-5 py-2 rounded text-sm" onClick={handleCloseStatusModal}>
                            Close
                        </button>
                    </div>
                </div>
            )}

        </div>
    )
}

export default ViewApplication